import { patchSignRequestLoanLenderBorrowerContract } from '@nemuru-eng/js-api-client';

import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import { StandardActionDialog } from '@/components/shared/components/StandardActionDialog/StandardActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

interface SendContractSignatureToBorrowerDialogProps {
  loanId: string;
  useDialogProps: UseDialogProps;
}

export const SendContractSignatureToBorrowerDialog = ({
  loanId,
  useDialogProps,
}: SendContractSignatureToBorrowerDialogProps) => {
  const { request, loading } = useRequest();

  const sendContractSignatureToBorrower = async () => {
    await request(patchSignRequestLoanLenderBorrowerContract, { id: loanId });
    useDialogProps.toggleDialog();
  };

  return (
    <StandardActionDialog
      titleTextElement={<Text tId={'SEND_CONTRACT_SIGNATURE_TO_BORROWER'} />}
      actionDescriptionTextElement={<Text tId={'ARE_YOU_SURE_YOU_WANT_TO_SEND_CONTRACT_SIGNATURE_TO_BORROWER'} />}
      opened={useDialogProps.opened}
      setOpened={useDialogProps.setOpened}
      setActionDialogParams={undefined}
      loading={loading}
      actionButtonsArray={[
        {
          onClick: () => sendContractSignatureToBorrower(),
          buttonLabelTextId: 'SEND_CONTRACT',
        },
      ]}
    />
  );
};
